import React from 'react'
//import { FacebookShareButton, FacebookIcon, TwitterShareButton, XIcon} from 'react-share';
import "./footer.css"
import Container from 'react-bootstrap/Container';

export const Footer = () => {
  return (
    <Container className="footerContainer">
      <div>
       
          Copyright &copy; DedaAI LLC
      
      {/*}
        <span style = {{marginLeft: '20px'}}>
        <FacebookShareButton url="https://your-facebook-profile.com" quote="Check out this amazing content!" hashtag="#react" style={{margin:'5px'}}>
            <FacebookIcon size={20} iconFillColor="white" borderRadius={50} />
          </FacebookShareButton>

          <TwitterShareButton url="https://DedaAI7755" body="This is a body" style={{margin:'5px'}}>
            <XIcon size={20} iconFillColor="white" borderRadius={50} />
          </TwitterShareButton>

        </span>
      */}

      
      </div>
    </Container>
    
  )
}

